import Loading from "components/elements/Loading/Loading";
import AutodeskSymbolSvg from "components/icons/autodesk-symbol.svg";
import { useAutodeskProjects } from "../lib/hooks/useAutodeskProjects";
import AutodeskBrowserRow from "../controls/AutodeskBrowserRow";
import AutodeskFilteredList from "../controls/AutodeskFilteredList";
import AutodeskRequestError from "../controls/AutodeskRequestError";
import { AutodeskImportStepProps } from "./AutodeskImportStepProps";

export default function AutodeskImportProjectStep(p: AutodeskImportStepProps) {
  const { projects, hasError, error, isLoading, mutate } = useAutodeskProjects(
    p.state.accountId,
    p.state.hub,
  );

  if (isLoading) return <Loading />;
  if (hasError)
    return (
      <AutodeskRequestError
        error={error}
        workspaceId={p.workspaceId}
        onRetry={() => mutate()}
        onReconnected={p.onReconnected}
      />
    );

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-thin">
        Select a <span className="font-normal">project</span>
      </h1>
      <AutodeskFilteredList
        items={projects ?? []}
        placeholder="Search projects"
        emptyText="No projects"
        getKey={(project) => project.id}
        getName={(project) => project.name}
        renderItem={(project) => (
          <AutodeskBrowserRow
            icon={<AutodeskSymbolSvg />}
            label={project.name}
            onClick={() => p.dispatch({ type: "CHOOSE_PROJECT", project })}
          />
        )}
      />
    </div>
  );
}
